import { Box, styled, Theme } from '@mui/material';
import FormControl from '@mui/material/FormControl';

export const ITEM_HEIGHT = 48;
export const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const StyledBox = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1.5,
});

export const getStyles = (
  name: string,
  labelName: readonly string[],
  theme: Theme,
) => {
  return {
    fontWeight:
      labelName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
};

export const StyledFormControl = styled(FormControl)(
  ({ $isViewOnly }: { $isViewOnly: boolean }) => ({
    minWidth: 600,
    m: 1,
    ...($isViewOnly && {
      pointerEvents: 'none',
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: 'lightgray',
      },
    }),
  }),
);
